import { callContext9kaeu539wjs3 as callContext } from '../Utils.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_CLIENT_CONFIG1oazdiwjd1qe0 as get_CLIENT_CONFIG } from '../HttpClientEngine.mjs';
import {
  isUpgradeRequest3msdo2i9hxs68 as isUpgradeRequest,
  get_ResponseAdapterAttributeKey1ll13ywinsgvd as get_ResponseAdapterAttributeKey,
  HttpResponseData2dozo5khuplr6 as HttpResponseData,
} from '../../request/HttpRequest.mjs';
import { GMTDate36bhedawynxlf as GMTDate } from '../../../../../../ktor-ktor-utils/io/ktor/util/date/DateJs.mjs';
import { toRawo597f5rz2rod as toRaw } from './JsUtils.mjs';
import { Companion_getInstance2ezhixu745xg5 as Companion_getInstance } from '../../JsRequestUtils.mjs';
import {
  get_job2zvlvce9o9a29 as get_job,
  cancel2en0dn4yvpufo as cancel,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  commonFetch16pkr2nd4pdev as commonFetch,
  readBody4gczno2wau05 as readBody,
} from './compatibility/Utils.mjs';
import {
  HttpStatusCode3o1wkms10pg4k as HttpStatusCode,
  Companion_getInstance3047yo46wk0eo as Companion_getInstance_0,
} from '../../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import { Companion_getInstance3v7nep4taho4u as Companion_getInstance_1 } from '../../../../../../ktor-ktor-http/io/ktor/http/HttpProtocolVersion.mjs';
import { CoroutineScopelux7s7zphw7e as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { equals2v6cggk171b6e as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { flatten2dh4kibw1u0qq as flatten } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { awaitopqeg9l1dqx0 as await_0 } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Promise.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { PlatformUtils_getInstanceitqdjrwn2jrm as PlatformUtils_getInstance } from '../../../../../../ktor-ktor-utils/io/ktor/util/PlatformUtils.mjs';
import {
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  intercepted2ogpsikxxj4u0 as intercepted,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_WEBSOCKETS_KEY4y3dps3lzl71 as get_WEBSOCKETS_KEY,
  WebSocketCapability_instance1mjnqrz16anqe as WebSocketCapability_instance,
  WebSocketExceptionb5mwyitzck0i as WebSocketException,
} from '../../plugins/websocket/WebSockets.mjs';
import { JsWebSocketSession2h93x4rgbt7zw as JsWebSocketSession } from '../../plugins/websocket/JsWebSocketSession.mjs';
import { CancellationExceptionjngvjj221x3v as CancellationException } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Exceptions.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  Companion_getInstance363ajpo4f7xlh as Companion_getInstance_2,
  headersOf2tgdoojg8tifn as headersOf,
} from '../../../../../../ktor-ktor-http/io/ktor/http/Headers.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpClientEngineBase2tgisnw4e4drr as HttpClientEngineBase } from '../HttpClientEngineBase.mjs';
import { HttpTimeoutCapability_instance3bnvoa2d7t5mf as HttpTimeoutCapability_instance } from '../../plugins/HttpTimeout.mjs';
import { SSECapability_instance2x56e2kozv2rg as SSECapability_instance } from '../../plugins/sse/SSE.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { dropCompressionHeaders12falb2m2fkr1 as dropCompressionHeaders } from '../../utils/HeadersUtils.mjs';
import { buildHeaders3beu05fiq9iq2 as buildHeaders } from '../../utils/headers.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import {
  Companion_instance25ullnynvxd0w as Companion_instance,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___init__impl__xyqfz83a5421h46yeyh as _Result___init__impl__xyqfz8,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_execute__d6syw1($this, data, $completion) {
  var tmp = callContext($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var callContext_0 = tmp;
  var clientConfig = data.n5l_1.u4m(get_CLIENT_CONFIG());
  if (isUpgradeRequest(data)) {
    var tmp_0 = executeWebSocketRequest($this, data, callContext_0, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return tmp_0;
  }
  var requestTime = GMTDate();
  var tmp_1 = toRaw(data, clientConfig, callContext_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var rawRequest = tmp_1;
  var tmp0_safe_receiver = data.n5l_1.v4m(Companion_getInstance().h5z_1);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r5z_1;
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    tmp_2 = JsClientEngine$execute$lambda;
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var fetchOptions = tmp_2;
  var tmp_3 = commonFetch(data.i5l_1.toString(), rawRequest, fetchOptions, $this.w5z_1, get_job(callContext_0), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var rawResponse = tmp_3;
  var status = new (HttpStatusCode())(rawResponse.status, rawResponse.statusText);
  var headers = mapToKtor(rawResponse.headers, data.j5l_1, data.n5l_1);
  var version = Companion_getInstance_1().z50_1;
  var body = readBody(CoroutineScope(callContext_0), rawResponse);
  var tmp2_safe_receiver = data.n5l_1.v4m(get_ResponseAdapterAttributeKey());
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.j5x(data, status, headers, body, data.l5l_1, callContext_0);
  var responseBody = tmp3_elvis_lhs == null ? body : tmp3_elvis_lhs;
  return new (HttpResponseData())(status, requestTime, headers, version, responseBody, callContext_0);
}
function *_generator_createWebSocket__urhgaf($this, urlString_capturingHack, headers, $completion) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = headers.p4o();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().u2();
  var _iterator__ex2g4s = tmp0.u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    if (equals(element, 'Sec-WebSocket-Protocol', true)) {
      destination.n2(element);
    }
  }
  var protocolHeaderNames = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList().u2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = protocolHeaderNames.u1();
  while (_iterator__ex2g4s_0.v1()) {
    var element_0 = _iterator__ex2g4s_0.w1();
    var tmp0_safe_receiver = headers.n4o(element_0);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.n2(tmp0_safe_receiver);
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = flatten(destination_0);
  var protocols = copyToArray(this_0);
  var tmp;
  if (PlatformUtils_getInstance().z4n_1) {
    tmp = new WebSocket(urlString_capturingHack, protocols);
  } else {
    var ws_import = import('ws');
    var tmp_0 = await_0(ws_import, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var ws_capturingHack = tmp_0.default;
    var headers_capturingHack = new (JsClientEngine$createWebSocket$headers_capturingHack$1())();
    headers.u4o((name, values) => {
      headers_capturingHack[name] = joinToString(values, ',');
      return Unit_instance;
    });
    tmp = new ws_capturingHack(urlString_capturingHack, protocols, {headers: headers_capturingHack});
  }
  return tmp;
}
function createWebSocket($this, urlString_capturingHack, headers, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createWebSocket__urhgaf.bind(VOID, $this, urlString_capturingHack, headers), $completion);
}
function *_generator_executeWebSocketRequest__7f0rb($this, request, callContext, $completion) {
  var requestTime = GMTDate();
  var urlString = request.i5l_1.toString();
  var wsConfig = request.n5l_1.u4m(get_WEBSOCKETS_KEY());
  var tmp = createWebSocket($this, urlString, request.k5l_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var socket = tmp;
  var session = new (JsWebSocketSession())(callContext, socket, wsConfig.h5w_1);
  try {
    var tmp_0 = awaitConnection(socket, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var cause = $p;
      cancel(callContext, CancellationException('Failed to connect to ' + urlString, cause));
      throw cause;
    } else {
      throw $p;
    }
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = socket.protocol;
  var tmp_1;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(this_0) > 0) {
    tmp_1 = this_0;
  } else {
    tmp_1 = null;
  }
  var protocol = tmp_1;
  var headers = !(protocol == null) ? headersOf('Sec-WebSocket-Protocol', protocol) : Companion_getInstance_2().p4z_1;
  return new (HttpResponseData())(Companion_getInstance_0().h51_1, requestTime, headers, Companion_getInstance_1().z50_1, session, callContext);
}
function executeWebSocketRequest($this, request, callContext, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_executeWebSocketRequest__7f0rb.bind(VOID, $this, request, callContext), $completion);
}
function JsClientEngine$execute$lambda(_this__u8e3s4) {
  return Unit_instance;
}
var JsClientEngine$createWebSocket$headers_capturingHack$1Class;
function JsClientEngine$createWebSocket$headers_capturingHack$1() {
  if (JsClientEngine$createWebSocket$headers_capturingHack$1Class === VOID) {
    class $ {}
    initMetadataForClass($);
    JsClientEngine$createWebSocket$headers_capturingHack$1Class = $;
  }
  return JsClientEngine$createWebSocket$headers_capturingHack$1Class;
}
var JsClientEngineClass;
function JsClientEngine() {
  if (JsClientEngineClass === VOID) {
    class $ extends HttpClientEngineBase() {
      constructor(config) {
        super('ktor-js');
        this.w5z_1 = config;
        this.x5z_1 = setOf([HttpTimeoutCapability_instance, WebSocketCapability_instance, SSECapability_instance]);
        // Inline function 'kotlin.check' call
        if (!(this.w5z_1.h5m_1 == null)) {
          var message = 'Proxy unsupported in Js engine.';
          throw IllegalStateException().o(toString(message));
        }
      }
      a5h() {
        return this.w5z_1;
      }
      p5l() {
        return this.x5z_1;
      }
      y5l(data, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_execute__d6syw1.bind(VOID, this, data), $completion);
      }
    }
    initMetadataForClass($, 'JsClientEngine', VOID, VOID, VOID, [1, 2]);
    JsClientEngineClass = $;
  }
  return JsClientEngineClass;
}
function mapToKtor(_this__u8e3s4, method, attributes) {
  return buildHeaders(($this$buildHeaders) => {
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.forEach((value, key) => {
      $this$buildHeaders.s4o(key, value);
      return Unit_instance;
    });
    dropCompressionHeaders($this$buildHeaders, method, attributes, PlatformUtils_getInstance().z4n_1);
    return Unit_instance;
  });
}
function awaitConnection(_this__u8e3s4, $completion) {
  var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
  cancellable.c11();
  $l$block: {
    var continuation = cancellable;
    if (continuation.bx()) {
      break $l$block;
    }
    var eventListener = (event) => {
      var tmp0_subject = event.type;
      var tmp;
      if (tmp0_subject === 'open') {
        var tmp0 = continuation;
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = _this__u8e3s4;
        var tmp$ret$1 = _Result___init__impl__xyqfz8(value);
        tmp0.tc(tmp$ret$1);
        tmp = Unit_instance;
      } else if (tmp0_subject === 'error') {
        var tmp0_0 = continuation;
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var exception = WebSocketException().c5w(asString(event));
        var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
        tmp0_0.tc(tmp$ret$3);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
    _this__u8e3s4.addEventListener('open', eventListener);
    _this__u8e3s4.addEventListener('error', eventListener);
    continuation.kz((it) => {
      _this__u8e3s4.removeEventListener('open', eventListener);
      _this__u8e3s4.removeEventListener('error', eventListener);
      var tmp;
      if (!(it == null)) {
        _this__u8e3s4.close();
        tmp = Unit_instance;
      }
      return Unit_instance;
    });
  }
  return cancellable.my();
}
function asString(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().q1();
  var tmp = JSON;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = ['message', 'target', 'type', 'isTrusted'];
  this_0.r1(tmp.stringify(_this__u8e3s4, tmp$ret$2));
  return this_0.toString();
}
//region block: exports
export {
  JsClientEngine as JsClientEngine2d6599fsx5fyf,
};
//endregion

//# sourceMappingURL=JsClientEngine.mjs.map
